import React from "react";
import { Link } from "react-router-dom";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { useLanguage } from "../../contexts/LanguageContext";
import LanguageSelector from "../common/LanguageSelector";

const logoUrl = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}/logojes.png`
  : "/logojes.png";

/**
 * Layout pour les visiteurs (non connectés)
 * Header sobre et professionnel, aligné avec la charte orange/ambre/slate
 */
const VisitorLayout = ({ children }) => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-amber-50/30">
      <header className="dark sticky top-0 z-50 border-b border-slate-700/60 bg-slate-900/85 backdrop-blur-xl shadow-[0_8px_24px_rgba(2,6,23,0.24)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 sm:h-[72px]">
            {/* Logo JesCook */}
            <Link
              to="/"
              className="group flex items-center gap-2.5 sm:gap-3 text-white transition-all"
              aria-label="JesCook accueil"
            >
              <div className="h-10 w-10 sm:h-11 sm:w-11 rounded-2xl bg-gradient-to-br from-slate-500 to-sky-700/80 p-0.5 shadow-md shadow-slate-900/30">
                <div className="h-full w-full rounded-[14px] bg-slate-950/80 flex items-center justify-center">
                  <img
                    src={logoUrl}
                    alt="JesCook"
                    className="h-6 sm:h-7 w-auto object-contain"
                  />
                </div>
              </div>
              <div className="hidden sm:block">
                <span className="text-[1.15rem] font-bold text-white tracking-[-0.01em]">
                  JesCook
                </span>
                <p className="text-[11px] uppercase tracking-[0.08em] text-slate-300/90 font-semibold -mt-0.5 group-hover:text-white/90 transition-colors">
                  {t("worldMenus")}
                </p>
              </div>
            </Link>

            {/* Desktop: langue + boutons */}
            <div className="hidden md:flex items-center gap-2.5">
              <LanguageSelector />
              <Link
                to="/auth"
                className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:border-indigo-300 dark:hover:border-indigo-600 transition-all duration-200 shadow-sm hover:shadow-md"
                aria-label={t("login")}
              >
                <HiOutlineUserCircle className="w-5 h-5" />
              </Link>
            </div>

            {/* Mobile: langue + auth directs dans le header */}
            <div className="flex md:hidden items-center gap-2">
              <LanguageSelector compact />
              <Link
                to="/auth"
                className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:border-indigo-300 dark:hover:border-indigo-600 transition-all duration-200 shadow-sm active:scale-95"
                aria-label={t("login")}
              >
                <HiOutlineUserCircle className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>
    </div>
  );
};

export default VisitorLayout;
